export const PATH = {
  LOGIN: '/login',
  DASHBOARD: '/',
  RESET_PASSWORD: '/reset-password',
  SEND_RESET_MAIL: '/send-reset-mail',
  SIGNUP: '/signup',
};

export const BILLING_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSegaJQFaE5wkNvPqcP_DnpKxVo7pdtXGZb02AB9q7WlRv9AGw/viewform';